



















































































































































































































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwRadio } from '@libs-uuif/shared/sw-radio';
import { IconConfig, SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { Component, Prop } from 'vue-property-decorator';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { steps } from './constant';
import { currentUserKey } from '../../shared/msw-constants';
import QrcodeVue from 'qrcode.vue';
import _ from 'lodash';
import { UserInfo } from './types';
import { messageService } from '@sonicwall/unified-ui-framework/src/shared/message-service';

const cssPrefix = 'tfaSetup';
@Component({
  components: {
    SwIcon,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwCheckbox,
    SwTextfield,
    QrcodeVue,
    SwRadio,
  },
})
export default class TfaSetup extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ type: Boolean, default: false, required: true })
  showTFASetupDialog: any;

  @Prop({ type: Boolean, default: false, required: true })
  declineTFA: any;

  @Prop({ type: String, default: '', required: true })
  password: any;

  currentStep: string = steps.ACTIVATE_STEP;
  steps: any = steps;
  twoFactorAuthSecret: string = '';
  showAppForManulEntry: boolean = false;
  generatedQrCode: string = '';
  inputForAppVerification: boolean = false;
  verificationAppCode: string = '';
  generatedTfaAuthCode: string = '';
  userInfo: Partial<UserInfo> = {};
  verificationEmailCode: string = '';
  inputForEmailVerification: boolean = false;
  selectEmail: string = '';
  tfaidFromResponse: string = '';
  onEnterAppCode: boolean = false;
  onEnterEmailCode: boolean = false;
  iconConfig: IconConfig = {
    name: 'view',
  };

  created() {
    const tempObj: any = localStorage.getItem(currentUserKey);
    this.userInfo = _.cloneDeep(tempObj && JSON.parse(tempObj)) || {};
    this.selectEmail = this.getEmail;
  }

  get getUserInfo(): Partial<UserInfo> {
    return this.userInfo;
  }

  get getHeader() {
    if (this.currentStep === steps.SETUP_APP_STEP) {
      return this.$t('login.setupViaAuthenticator')
        .toString();
    }
    if (this.currentStep === steps.SETUP_EMAIL_STEP) {
      return this.$t('login.emailSetupHeadline')
        .toString();
    }
    return this.$t('login.forceTFAHeadline')
      .toString();
  }

  get getNameToDisplay() : string {
    return this.getUserInfo.displayName || '';
  }

  get getEmail() :string {
    return this.getUserInfo.email || '';
  }

  onClickSkipForceTfa() {
    this.$store.commit('mutate', { property: 'isGuestBuyNowUser', with: false });
    this.$store.commit('mutate', { property: 'loggedIn', with: true });
    if (this.$router.currentRoute.query!.redirectURL) {
      this.$router.push({ path: atob(this.$router.currentRoute.query.redirectURL as string) });
    } else if (this.$route.query.loginmode &&
      this.$route.query.loginmode.toString() === 'guestbuynow') {
      this.$router.push({ path:'/m/feature/cart' });
    } else {
      this.$router.push({ path:'/m/feature/dashboard' });
    }
  }

  onClickManuallyCode() {
    this.showAppForManulEntry = true;
  }

  onClickActivate() {
    this.currentStep = steps.SETUP_APP_STEP;
    this.showQRCode();
  }

  goToEmailSetup() {
    this.showAppForManulEntry = false;
    this.generatedQrCode = '';
    this.inputForAppVerification = false;
    this.verificationAppCode = '';
    this.currentStep = steps.SETUP_EMAIL_STEP;
  }

  showQRCode() {
    this.generateIdForQRcode();
  }

  onInputForAppVerification() {
    this.inputForAppVerification = true;
    this.setupTextField('appverificationcode');
    this.makeFocus('appverificationcode');
  }

  generateIdForQRcode() {
    const base32 = require('hi-base32');
    let text = '';
    const possible: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 10; i = i + 1) {
      text = `${text}${possible.charAt(Math.floor(Math.random() * possible.length))}`;
    }
    this.generatedTfaAuthCode = text;
    this.generatedQrCode = base32.encode(text);
    const chunks = [];
    for (let i = 0, charsLength = this.generatedQrCode.length; i < charsLength; i += 4) {
      chunks.push(this.generatedQrCode.substring(i, i + 4));
    }
    this.generatedQrCode = chunks.join('-');
    this.generateCode();
  }

  generateCode() {
    const id = this.generatedQrCode;
    const email = this.getUserInfo?.email || '';
    this.twoFactorAuthSecret = `otpauth://totp/MySonicWall:${email}?secret=${id}&issuer=MySonicWall`;
  }

  onClickVerifyAnSave(type: string) {
    if (type === 'authApp') {
      this.onEnterAppCode = true;
      if (this.verificationAppCode) {
        const request = {
          twofactorAuthMode: 'APP',
          userlogin: this.$store.getters.getUserId,
          phoneNo: '',
          captchaText: '',
          twofactorKeyCode: this.generatedTfaAuthCode || '',
          TFACode: this.verificationAppCode || '',
        };
        this.$store.dispatch('SnbProfileStoreModule/verifyTFA', request)
          .then((response: any) => {
            if (response.msgCode === 'MSWAPP:VERIFYTFASUCCESS' && response.operationStatus === 'OK') {
              this.tfaidFromResponse = '';
              this.updateAppTfaSetting('APP');
            } else {
              messageService.messageManager
                .showMessage('login-message', response.msgDesc , 'failed');
            }
          })
          .catch((err: any) => {
            messageService.messageManager
              .showMessage('login-message', err.message , 'failed');
          })
          .finally(() => {
            this.$store.commit('stopLoading');
          });
      }
    } else {
      this.onEnterEmailCode = true;
      try {
        this.tfaidFromResponse = localStorage.getItem('TFAID') || '';
      } catch (e) {
        console.error(e);
      }
      if (this.verificationEmailCode) {
        const request = {
          twofactorAuthMode: 'EMAIL',
          userlogin: this.$store.getters.getUserId,
          phoneNo: '',
          captchaText: '',
          twofactorKeyCode: '',
          TFACode: this.verificationEmailCode,
          TFAID: this.tfaidFromResponse || '',
        };
        this.$store.dispatch('SnbProfileStoreModule/verifyTFA', request)
          .then((response: any) => {
            if (response.msgCode === 'MSWAPP:VERIFYTFASUCCESS' && response.operationStatus === 'OK') {
              this.tfaidFromResponse = '';
              try {
                localStorage.removeItem('TFAID');
              } catch (e) {
                console.error(e);
              }
              this.updateAppTfaSetting('EMAIL');
            } else {
              if (response.msgCode === 'MSWAPP:TFAEMAILAUTHFAIL') {
                this.verificationEmailCode = '';
              }
              messageService.messageManager
                .showMessage('login-message', response.msgDesc , 'failed');
            }
          })
          .catch((err: any) => {
            this.verificationEmailCode = '';
            messageService.messageManager
              .showMessage('login-message', err.message , 'failed');
          })
          .finally(() => {
            this.$store.commit('stopLoading');
          });
      }
    }
  }

  goToMobileSetup() {
    this.verificationEmailCode = '';
    this.inputForEmailVerification = false;
    this.currentStep = steps.SETUP_APP_STEP;
    this.showQRCode();
  }

  closeDialog() {
    this.$emit('closeTFASetupDialog');
  }

  onClickResendEmailCode() {
    this.tfaidFromResponse = '';
    this.verificationEmailCode = '';
    this.onClickEmailSetup();
  }

  onClickEmailSetup() {
    this.tfaidFromResponse = '';
    const request = {
      twofactorAuthMode: 'EMAIL',
      userlogin: this.$store.getters.getUserId,
      phoneNo: '',
      captchaText: '',
      twofactorKeyCode: '',
      TFACode: '',
      TFAID: this.tfaidFromResponse || '',
    };
    this.$store.dispatch('SnbProfileStoreModule/verifyTFA', request)
      .then((response: any) => {
        if (response.operationStatus === 'OK') {
          this.inputForEmailVerification = true;
          this.tfaidFromResponse = response?.TFAID || '';
          try {
            localStorage.setItem('TFAID', this.tfaidFromResponse);
          } catch (e) {
            console.error(e);
          }
          this.setupTextField('emailverificationcode');
          this.makeFocus('emailverificationcode');
          messageService.messageManager
            .showMessage('login-message', response.msgDesc , 'success');
        } else {
          messageService.messageManager
            .showMessage('login-message', response.msgDesc , 'failed');
        }
      })
      .catch((err: any) => {
        messageService.messageManager
          .showMessage('login-message', err.message , 'failed');
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  updateAppTfaSetting(mode: string) {
    const requestBody = {
      tfaMode: mode,
      tfaAuthCode: mode === 'APP' ? this.generatedTfaAuthCode : '',
    };
    this.$store
      .dispatch('SnbProfileStoreModule/setTFAPreference', requestBody)
      .then((response: any) => {
        if (response.msgCode === 'MSWAPP:SUCCESS') {
          this.generatedTfaAuthCode = '';
          messageService.messageManager
            .showMessage('login-message', response.msgDesc , 'success');
          this.onClickSkipForceTfa();
        } else {
          mode === 'APP' ? (this.verificationAppCode = '') : (this.verificationEmailCode = '');
          messageService.messageManager
            .showMessage('login-message', response.msgDesc , 'failed');
        }
      })
      .catch((error) => {
        mode === 'APP' ? (this.verificationAppCode = '') : (this.verificationEmailCode = '');
        messageService.messageManager
          .showMessage('login-message', error.message , 'failed');
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  makeFocus(ref: string) {
    this.$nextTick(() => {
      if ((this.$refs[ref] as SwTextfield)) {
        (this.$refs[ref] as SwTextfield).focus();
      }
    });
  }

  setupTextField(ref: string) {
    this.$nextTick(() => {
      if ((this.$refs[ref] as SwTextfield)) {
        // tslint:disable-next-line
        (this.$refs[ref] as SwTextfield)?.$el?.getElementsByClassName('sw-textfield__wrapper')[0]?.querySelector('.sw-icon')?.setAttribute('style', 'cursor: pointer');
        // tslint:disable-next-line
        (this.$refs[ref] as SwTextfield)?.$el?.getElementsByClassName('sw-textfield__wrapper')[0]?.querySelector('.sw-icon')?.addEventListener('click', () => {
           // tslint:disable-next-line
          (this.$refs[ref] as SwTextfield)?.$el?.getElementsByTagName('input')[0]?.setAttribute('type', 'text');
        });
        // tslint:disable-next-line
        (this.$refs[ref] as SwTextfield)?.$el?.getElementsByClassName('sw-textfield__wrapper')[0]?.querySelector('.sw-icon')?.addEventListener('mouseout', () => {
           // tslint:disable-next-line
          (this.$refs[ref] as SwTextfield)?.$el?.getElementsByTagName('input')[0]?.setAttribute('type', 'password');
        });
      }
    });
  }
}
